<template>
  <div class="login-prompt no-print">
    <p>{{ message }}</p>
    <button @click="authStore.openAuthModal()">Se connecter</button>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/useAuthStore';

// Encart affiché aux visiteurs anonymes sur les pages publiques en version réduite
// (inscrits, classements) : invite à se connecter pour obtenir le reste des infos.
defineProps<{ message: string }>();

const authStore = useAuthStore();
</script>

<style scoped>
.login-prompt {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem 1.25rem;
  padding: 1rem 1.25rem;
  margin-bottom: 1.5rem;
  border: 1px solid var(--color-light-shadow, #ddd);
  border-radius: var(--radius, 8px);
  background: var(--color-bg-lighter, #f5f5f5);
  text-align: center;
}

.login-prompt p {
  margin: 0;
}
</style>
